import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import NavMenu from '@/components/NavMenu'
import Tech from '@/components/Tech'
import ServiceCase from '@/components/ServiceCase'
import Apply from '@/components/Apply'
import NewsArticle from '@/components/News'
import Product from '@/components/Product'
import NewsList from '@/components/NewsList'

import ManageHome from '@/components/manage/ManageHome'
import Article from '@/components/manage/NewsManage'
import LogList from '@/components/manage/LogList'
import ServicesList from '@/components/manage/ServicesManage'
import Carousel from '@/components/manage/Carousel'
import Banner from '@/components/manage/Banner'
import UserList from '@/components/manage/UserManage'
import MenuList from '@/components/manage/MenuManage'
import ProductList from '@/components/manage/ProductManage'
import Settings from '@/components/manage/Settings'
import ApplyManage from '@/components/manage/ApplyManage'
import Overview from '@/components/manage/Overview'
import TechManage from '@/components/manage/TechManage'
import Cooperation from '@/components/manage/Cooperation'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes: [
    {
      path: '/Login',
      component: Login,
    },
    {
      path: '/',
      redirect: '/Home',
      name: 'NavMenu',
      component: NavMenu,
      children: [
        { path: 'Home', component: Home },
        { path: 'KeyTech', component: Tech },
        { path: 'ServiceCase', component: ServiceCase,},
        { path: 'Apply', component: Apply },
        { path: 'Product', component: Product },
        { path: 'NewsList', component: NewsList,},
        { path: 'Article/:id', component: NewsArticle },
      ]
    },
    {
      path: '/Manage',
      redirect: 'Manage/Message',
      name: 'Manage',
      component: ManageHome,
      children: [
        { path: 'Banner', component: Banner },
        { path: 'Carousel', component: Carousel },
        { path: 'Article', component: Article },
        { path: 'Service', component: ServicesList },
        { path: 'Log', component: LogList },
        { path: 'User', component: UserList },
        { path: 'Menu', component: MenuList },
        { path: 'Message', component: ApplyManage },
        { path: 'Setting', component: Settings },
        { path: 'Home', component: Overview },
        { path: 'Tech', component: TechManage },
        { path: 'Product', component: ProductList,},
        { path: 'Cooperation', component: Cooperation,},
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js